import _				from "lodash";

import { Service }		from "./../../Libs/Service";

import { Template } 	from "./Template";
import { Layout } 		from "./Layout";
import { Section } 		from "./Section";
import { Settings } 	from "./Settings";
import { Asset } 		from "./Asset";

import SetupSettings 	from "../settings/settings";
import {Server} from "./Server";
import dayjs from "dayjs";

let Project = new Service({

	Name: "Project",

	Events: {

		'Selected Template Changed': function() {

			//this.autoSelectFolder();
			this.autoSelectProject();

		},

		'Project Selected': function(projectId) {

			this.SelectedProject = this.Projects[projectId];

			Broadcast.call("Selected Project Changed", [projectId]);

			if (!this.SelectedProject || !this.SelectedProject.folder_id) {
					window.localStorage.setItem('selected-folder-for-template-' + Template.SelectedTemplate.id, null);

					this.SelectedFolder = null;

					Broadcast.call("Selected Folder Changed", [null]);
			}

		},

		'Folder Selected': function(folderId) {

			this.SelectedFolder = this.Folders[folderId];

			Broadcast.call("Selected Folder Changed", [folderId]);

		}

	},

	Actions: {

		'ProjectsAndFolders': function(data) {

			this.updateFolders(data.Folders);
			this.updateProjects(data.Projects);

			Broadcast.call("Projects Changed", [data.Projects]);

			if (!this.SelectedProject) this.autoSelectProject();

		},

		'Projects': function (projects) {

			this.updateProjects(projects);

			Broadcast.call("Projects Changed", [projects]);

			if (Object.values(projects).length === 1) {
				let project = Object.values(projects)[0];
				if (project.id === this.SelectedProject.id) {
					let folder_id = project.folder_id ? project.folder_id : null;
					this.selectFolder(folder_id);
				}
			}

			if (!this.SelectedProject) this.autoSelectProject();
		},

		'ProjectsAdditionalData': function (projects) {

			this.updateProjects(projects);

		},

		'Folders': function(folders) {

			this.updateFolders(folders);

			Broadcast.call("Folders Changed", [folders]);

		},

		'ProjectSectionsChanges': function(changes) {

			changes = Object.values(changes).reverse();
			let timezoneOffset = (new Date()).getTimezoneOffset();
			changes.forEach(change => {
				let timestamp = dayjs(change.timestamp).add(timezoneOffset / 60, 'hour');
				change.timestampFormatted = timestamp.format('HH:mm') + ' ' + timestamp.format('MMM-DD');
			});

			Broadcast.call('Project Sections Changes Received', [changes]);

		},

		'ProjectsByTemplates': function (projects) {

			Broadcast.call('Projects By Template Received', [projects]);

		},

		'GlobalSearchProjects': function (data) {
			Broadcast.call("Global Search Results", [data]);
		}

	},

	init() {

		this.Projects = {};
		this.Folders = {};

		this.SelectedProject = null;
		this.SelectedFolder = null;

	},

	updateProjects(projects) {


		_.each(projects, (project, projectId) => {

			projectId = parseInt(projectId);

			if (!project) {

				let oldProject = this.Projects[projectId];

				if (oldProject) delete this.Projects[projectId];

				if (this.SelectedProject && this.SelectedProject.id === projectId) this.autoSelectProject();

			} else {

				if (project.AdditionalData && project.AdditionalData.timestamp) {
					project.timestamp = project.AdditionalData.timestamp || 0;
					project.lastUploaded = new dayjs(project.AdditionalData.timestamp).format('HH:mm\nMMM D');
				} else {
					project.lastUploaded = ''
				}

				this.Projects[project.id] = project;

				if (this.SelectedProject && this.SelectedProject.id === project.id) this.SelectedProject = project;

			}



			Broadcast.call("Project Changed", [projectId]);

			if (project && this.SelectedProject && this.SelectedProject.id === projectId) Broadcast.call("Selected Project Changed", [projectId]);

		});

	},

	updateFolders(folders) {

		_.each(folders, (folder, folderId) => {

			folderId = parseInt(folderId);

			if (!folder) {

				let oldFolder = this.Folders[folderId];

				if (oldFolder) delete this.Folders[folderId];

				//if (this.SelectedFolder && this.SelectedFolder.id === folderId) this.autoSelectFolder();

			} else {

				this.Folders[folder.id] = folder;

				if (this.SelectedFolder && this.SelectedFolder.id === folder.id) this.SelectedProject = folder;

			}

			Broadcast.call("Folder Changed", [folderId]);

			if (folder && this.SelectedFolder && this.SelectedFolder.id === folderId) Broadcast.call("Selected Folder Changed", [folderId]);

		});

	},

	getProjectsByTemplate(templateId) {

		return _.filter(this.Projects, {template_id: templateId});

	},

	getFoldersByTemplate(templateId) {

		return _.filter(this.Folders, {template_id: templateId});

	},

	autoSelectFolder() {

		if (Template.SelectedTemplate) {

			let folderId = window.localStorage.getItem('selected-folder-for-template-' + Template.SelectedTemplate.id);

			if (Project.Folders[folderId]) return this.selectFolder(folderId);

		}

	},

	autoSelectProject() {

		if (Template.SelectedTemplate) {

			if (Layout.layout === 'preview') {

				/*let version = _.values(Project.Versions)[0];

				if (!version) return;

				if (version && version.AdditionalData._oldSettingsId) this.selectSettings(Template.SelectedTemplate.id, version.AdditionalData._oldSettingsId);

				else if (Template.SelectedTemplate.BaseSettings[version.codename]) this.selectSettings(Template.SelectedTemplate.id, version.codename);

				else if (_.values(Template.SelectedTemplate.BaseSettings)[0]) this.selectSettings(Template.SelectedTemplate.id, _.values(Template.SelectedTemplate.BaseSettings)[0]["name"]);*/

			} else {

				if (Object.values(this.Projects).length === 0) return;

				let projectId = window.localStorage.getItem('selected-project-for-template-' + Template.SelectedTemplate.id);


				if (Project.Projects[projectId]) {

					return this.selectProject(projectId);

				}


				let templateProjects = _.filter(Project.Projects, p => p["template_id"] === Template.SelectedTemplate.id);

				if (templateProjects[0]) {
					return this.selectProject(templateProjects[0].id);
				}
				else {
					return this.selectProject(null);
				}

			}

		}

	},

	selectProject(projectId) {

		window.localStorage.setItem('selected-project-for-template-' + Template.SelectedTemplate.id, projectId);

		Broadcast.call("Project Selected", [projectId]);

		Server.sendToSocket({
			SelectedProject: projectId
		});

		let project = this.Projects[projectId];

		if (project && project.folder_id) {
			Broadcast.call("Folder Selected", [project.folder_id]);
		}

	},

	selectFolder(folderId) {

		window.localStorage.setItem('selected-folder-for-template-' + Template.SelectedTemplate.id, folderId);

		let project = Object.values(this.Projects).find(project => project.folder_id === folderId);

		Broadcast.call("Folder Selected", [folderId]);

		// if (project && project.id) Broadcast.call("Project Selected", [project.id]);

	},

	moveToFolder(folderId) {

		if (this.SelectedProject) {
			let projectId = this.SelectedProject.id;
			Server.sendToSocket({
				MoveToFolder: {
					projectId: projectId,
					folderId: folderId
				}
			});
		}

	},

	getSettings() {

		let projectSections = Section.getSelectedProjectSectionsById();
		Object.values(projectSections).forEach(section => {
			delete section.data;
			if (section.type === 'image') {
				delete section.Data.collapsedAnchorX;
				delete section.Data.collapsedAnchorY;
				delete section.Data.collapsedWidth;
				delete section.Data.collapsedHeight;
				delete section.Data.collapsedOffsetX;
				delete section.Data.collapsedOffsetY;
				delete section.Data['controls-color'];
				delete section.Data.heightRatio;
				delete section.Data['horizontal-spacing'];
				delete section.Data.html;
				delete section.Data['loop-video'];
				delete section.Data['play-on-load'];
				delete section.Data['play-sound-on-hover'];
				delete section.Data['show-mute-button'];
				delete section.Data['show-play-button'];
				delete section.Data['start-collapsed'];
				delete section.Data['vertical-spacing'];
				delete section.Data.videoSizeMode;
				delete section.Data.widthRatio;
			}
			if (section.type === 'image' && section.template_id !== 5) {
				delete section.Data.video;
			}
		});

		let stylesMode;
		let websitesPath;
		let stylesPath;
		let websitesFolder;
		let stylesFolder;
		let templateId = this.SelectedProject.template_id;

		switch (SetupSettings["domain"]) {
			case 'localhost':
				websitesFolder = 'prvk-websites-temp';
				if (templateId === 5) websitesFolder = 'prvk-websites-mobile-temp';
				//else if (templateId === 8) websitesFolder = 'prvk-websites-interscroller-temp';

				stylesFolder = websitesFolder;
				if (templateId === 8) stylesFolder = 'prvk-websites-temp';

				websitesPath = `${Server.Config['amazon-s3-cdn-url']}${websitesFolder}/`;
				stylesPath = `${Server.Config['amazon-s3-cdn-url']}${stylesFolder}/`;
				stylesMode = 'temp';
				break;
			case 'mraid.io':
				websitesFolder = 'prvk-websites-mraid';
				if (templateId === 5) websitesFolder = 'prvk-websites-mobile-mraid';
				//else if (templateId === 8) websitesFolder = 'prvk-websites-interscroller-mraid';

				stylesFolder = websitesFolder;
				if (templateId === 8) stylesFolder = 'prvk-websites-mraid';

				websitesPath = `${Server.Config['amazon-s3-cdn-url']}${websitesFolder}/`;
				stylesPath = `${Server.Config['amazon-s3-cdn-url']}${stylesFolder}/`;
				stylesMode = 'mraid';
				break;
			default:
				websitesFolder = 'prvk-websites';
				if (templateId === 5) websitesFolder = 'prvk-websites-mobile';
				//else if (templateId === 8) websitesFolder = 'prvk-websites-interscroller';

				stylesFolder = websitesFolder;
				if (templateId === 8) stylesFolder = 'prvk-websites';

				websitesPath = `${Server.Config['amazon-s3-cdn-url']}${websitesFolder}/`;
				stylesPath = `${Server.Config['amazon-s3-cdn-url']}${stylesFolder}/`;
				stylesMode = 'default';
				break;
		}

		return {
			Template: _.omit(Template.SelectedTemplate, ["html", "js"]),
			Project: this.SelectedProject,
			ProjectSections: Section.getSelectedProjectSectionsById(),
			ProjectSettings: Settings.getSelectedProjectSettingsByCodename(),
			ProjectAssets: Asset.getSelectedProjectMergedAssets(),
			overlayTransparency: parseInt(window.localStorage.getItem('overlay-transparency')),
			websitesPath: websitesPath,
			stylesPath: stylesPath,
			//Websites: Metadata.Websites,
			dashboard: true,
			stylesMode: stylesMode,
			dev: SetupSettings["dev"]
		};

	},

	getScript() {

		let settings = this.getSettings();
		let script = Template.SelectedTemplate["js"];

		let scriptSettingsString = JSON.stringify(settings, null, 4);
		let scriptSettings = `Settings = ${scriptSettingsString};`;

		script = _.replace(script, /\/\/#settings-injection-place/, scriptSettings.replaceAll('<script>', '\\<script\\>').replaceAll('</script>', '\\</script\\>'));

		return script;
	},

	getUrl(html) {

		if (!this.SelectedProject) return null;

		let blob = new Blob([html], {type: 'text/html'});

		return URL.createObjectURL(blob);

	},

	buildDefaultHtml() {

		let overlayId = Template.SelectedTemplate.id === 5 ? 2 : 1;
		if (Template.SelectedTemplate.id === 9) overlayId = 3;
		let html = Metadata.Overlays[overlayId]["html"];
		let script = this.getScript();

		html = _.replace(html, /{{assetsPath}}/g, this.getSelectedOverlayAssetsPath(Metadata.Overlays[overlayId]));
		html = html.replace('<!--creative script place-->', `<script>${script}</script>`);

		let blob = new Blob([script], {type: 'text/javascript'});
		html = html.replace('creative script src', URL.createObjectURL(blob))

		return html;

	},

	getSelectedProjectAssetsPath() {

		if (!this.SelectedSettings) return null;

		return `${location.protocol}//${SetupSettings["domain"]}:${(location.protocol === 'https:' ? SetupSettings["portSSL"] : SetupSettings["port"])}/templates/00${Template.SelectedTemplate.id}-${Template.SelectedTemplate.codename}//`

	},

	getSelectedOverlayAssetsPath(overlay) {

		if (!Template.SelectedTemplate) return null;

		return `${location.protocol}//${SetupSettings["domain"]}:${(location.protocol === 'https:' ? SetupSettings["portSSL"] : SetupSettings["port"])}/overlays/00${overlay.id}-${overlay.codename}/assets/`

	}

});

//Делаем глобальную ссылку для дебага - чтобы в консоли был виден этот объект сразу
window.Project = Project;

export { Project }

